import * as tokenStorage from '../../../utils/tokenStorage';

/** Display name for "בשמי" track-changes attribution in skill workflows. */
export function getStoredUserDisplayName(): string {
  try {
    const raw = tokenStorage.getUser();
    if (!raw) return 'Unknown';
    const user = JSON.parse(raw) as { full_name?: string; name?: string; email?: string };
    const name = (user.full_name || user.name || '').trim();
    if (name) return name;
    const email = (user.email || '').trim();
    if (email.includes('@')) return email.split('@')[0];
    return email || 'Unknown';
  } catch {
    return 'Unknown';
  }
}
